import Lang from 'lang.js';

let strings = {};
['en'].forEach(language => {
    ['admin', 'auth', 'common', 'messages', 'pagination', 'passwords', 'validation'].forEach(resource => {
        strings[`${language}.${resource}`] = require(`../../../../lang/${language}/${resource}.php`);
    });
});

window.lang = new Lang({
    messages: strings,
});
export default window.lang;
